// @flow
import { useEffect } from 'react';
import scriptLoader from '../helpers/scriptLoader';

const debug = require('debug')('jp:solvemate');

const SolveMateWidget = () => {
  useEffect(() => {
    window.solvemateConfig = {
      projectID: '5dee24f4569a12536c4ce26b'
    };

    debug('Load widget');
    scriptLoader('https://widget.solvemate.com/v2/init.js', true, false, []);
  }, []);

  return null;
};

export default SolveMateWidget;
